"use client";

import { useEffect } from "react";
import { createClient } from "@/lib/supabase/client";
import { migrateGuestDataToAccount } from "@/lib/local-portfolio/migrate";

/** Unsichtbar, einmal global gemountet (app/layout.tsx): uebernimmt lokal gespeicherte
 * Gast-Watchlist/-Depot-Eintraege automatisch, sobald eine Session entsteht (Login oder
 * bestaetigte Registrierung). Siehe lib/local-portfolio/migrate.ts. */
export function GuestDataMigrator() {
  useEffect(() => {
    const supabase = createClient();
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      if (event !== "SIGNED_IN" || !session?.user) return;
      void migrateGuestDataToAccount(supabase, session.user.id);
    });
    return () => subscription.unsubscribe();
  }, []);

  return null;
}
